// components/ControlledAutocomplete.tsx
import { ClearRounded } from '@mui/icons-material';
import { Autocomplete, CircularProgress, TextField } from '@mui/material';
import React from 'react';
const ControlledAutocomplete = ({
    name,
    keyName = 'name',
    errorName = '',
    field,
    options,
    inputValue,
    label = '',
    viewOnly = false,
    loading = false,
    setInputValue,
    styles = {},
    errors = {},
    onChange,
    onInputChange,
}) => {
    return (
        <Autocomplete
            disabled={viewOnly}
            freeSolo
            id={`${name}-autocomplete`}
            clearIcon={!loading && <ClearRounded fontSize="small" />}
            forcePopupIcon={!loading}
            getOptionLabel={(option) => (typeof option === 'string' ? option : option[keyName])}
            options={
                options?.length > 0
                    ? !inputValue || options.some((item) => item[keyName]?.toLowerCase() === inputValue?.trim()?.toLowerCase())
                        ? options
                        : [{ _id: 'new', keyName: inputValue }, ...options]
                    : inputValue
                      ? [{ _id: 'new', keyName: inputValue }]
                      : []
            }
            value={options?.find((opt) => opt?.[keyName]?.toLowerCase() === field?.value?.toLowerCase()) || null}
            inputValue={inputValue || ''}
            ListboxProps={{
                style: { maxHeight: '280px' },
            }}
            onInputChange={(event, newInputValue) => {
                let trimmedValue = newInputValue.trimStart();
                if (name === 'invoice-number') {
                    onInputChange(event, trimmedValue);
                } else {
                    setInputValue(trimmedValue);
                    field.onChange(trimmedValue);
                }
            }}
            onChange={(event, newValue) => {
                if (name === 'feeName') {
                    onChange(event, newValue);
                } else if (name === 'invoice-number') {
                    onChange(event, newValue);
                } else {
                    //   const selectedName = newValue?.partName || "";
                    //   field.onChange(selectedName);
                }
            }}
            renderOption={(props, option) => {
                if (option._id === 'new') return null;
                return (
                    <li {...props} key={option._id || `temp-${option[keyName]}-${Math.random()}`} style={{ height: '44px', paddingRight: 0 }}>
                        {option[keyName]}
                    </li>
                );
            }}
            renderInput={(params) => {
                const hasValue = inputValue || field?.value;
                const baseStyle = viewOnly ? styles.disabled : styles.active;
                return (
                    <TextField
                        {...params}
                        label={label}
                        variant="outlined"
                        error={errorName ? !!errors?.[errorName] : !!errors?.[keyName]}
                        helperText={errorName ? errors?.[errorName]?.message || '' : errors?.[keyName]?.message || ''}
                        InputProps={{
                            ...params.InputProps,
                            endAdornment: (
                                <>
                                    {loading ? <CircularProgress size={20} /> : null}
                                    {params.InputProps.endAdornment}
                                </>
                            ),
                        }}
                        sx={[
                            baseStyle,
                            hasValue &&
                                !viewOnly && {
                                    '& .MuiInputBase-root': {
                                        paddingRight: '56px !important',
                                    },
                                },
                            {
                                '& .MuiAutocomplete-endAdornment': {
                                    right: hasValue && !viewOnly ? '8px' : undefined,
                                    display: 'flex',
                                    gap: '4px',
                                },
                            },
                        ]}
                    />
                );
            }}
        />
    );
};

export default ControlledAutocomplete;
